var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-filter-dash__advanced" },
    [
      _vm._l(_vm.advancedQuery, function (query, index) {
        return _c("filter-advanced-input", {
          key: index,
          attrs: {
            query: query,
            index: index,
            options: _vm.options,
            selectedKeys: _vm.selectedKeys,
          },
          on: {
            selectKey: _vm.selectKey,
            selectValue: _vm.selectValue,
            submitValue: _vm.search,
            updateList: _vm.updateList,
            removeItem: _vm.deleteQueryItem,
            updateAmount: _vm.updateAmount,
            updateDate: _vm.setDate,
          },
        })
      }),
      _vm.advancedQuery.length < _vm.options.length
        ? _c("div", { staticClass: "eu-my_4" }, [
            _c(
              "button",
              {
                staticClass: "emd-btn _type_text _color_secondary _size_small",
                class: { _disabled: _vm.loadingList },
                attrs: {
                  "data-testid": "dropdown-advanced-filter-add-filter",
                  type: "button",
                },
                on: { click: _vm.addQueryItem },
              },
              [
                _c("i", { staticClass: "uil uil-plus-square" }),
                _vm._v(" " + _vm._s(_vm.$t("add-filter")) + " "),
              ]
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "emd-filter-dash__buttons" }, [
        _vm.totalQueries === 0 && _vm.searchClicked
          ? _c(
              "div",
              { staticClass: "emd-text _color_danger eu-shrink_1 eu-py_2" },
              [_c("span", [_vm._v(_vm._s(_vm.$t("warning-no-value")))])]
            )
          : _vm._e(),
        _c("span", [
          _c(
            "button",
            {
              staticClass: "emd-btn _type_text _size_small eu-mr_2",
              class: { _disabled: _vm.loadingList },
              attrs: {
                type: "button",
                "data-testid": "dropdown-advanced-filter-remove-filter",
                alt: _vm.$t("clean-filters"),
              },
              on: { click: _vm.cleanAdvancedQuery },
            },
            [
              _c("i", { staticClass: "uil uil-trash" }),
              _vm._v(" " + _vm._s(_vm.$t("clean-filters")) + " "),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "emd-btn _color_primary _size_small",
              class: { _disabled: _vm.loadingList },
              attrs: {
                type: "submit",
                "data-testid": "advanced-filter-btn",
                alt: _vm.$t("search"),
                disabled: _vm.formIsInvalid,
              },
              on: { click: _vm.search },
            },
            [
              _c("i", { staticClass: "uil uil-search" }),
              _vm._v(" " + _vm._s(_vm.$t("search")) + " "),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }